export default import.meta.ROLLUP_FILE_URL_8KByd7W0oH8zGe1MvrBFUw;